function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M-7753.829-1004.648l.263-29.809a.753.753,0,0,1,1.316-.573l12.653,15.077a.848.848,0,0,1,0,1.088l-12.917,14.791a.7.7,0,0,1-.544.272A.812.812,0,0,1-7753.829-1004.648Zm-17.07,0,.263-29.809a.755.755,0,0,1,1.318-.573l12.651,15.077a.848.848,0,0,1,0,1.088l-12.915,14.791a.7.7,0,0,1-.546.272A.812.812,0,0,1-7770.9-1004.648Z",
  transform: "translate(-7738.851 -1003.303) rotate(180)",
  fill: "#109dff",
  stroke: "rgba(0,0,0,0)",
  strokeWidth: 1
});

function SvgTitrePrec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.548,
    height: 32.52,
    viewBox: "0 0 32.548 32.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitrePrec);
export default __webpack_public_path__ + "static/media/titre_prec.5184bfb9.svg";
export { ForwardRef as ReactComponent };